
import ReviewUser from '@/components/review/ReviewUser.vue';
import ReviewStars from '@/components/review/ReviewStars.vue';
import ReviewAvatar from '@/components/review/ReviewAvatar.vue';

export default {
  name: 'ReviewHeader',
  components: { ReviewAvatar, ReviewUser, ReviewStars },
  props: {
    user: {
      type: Object,
      default: () => ({ profile: null, name: null }),
    },
    userChildrenAge: { type: Number, default: 0 },
    createdAt: { type: String, default: null },
    rating: { type: Number, default: 0 },
    index: { type: Number, required: true },
  },
  computed: {
    profileImage() {
      const imageNumber = (this.index % 5) + 1;
      return `/img/review/review_img${imageNumber}.png`;
    },
  },
};
